import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { HONORED_LIST, HONORED_ADDEDIT, HONORED_CHANGE_STATUS, HONORED_DELETE } from "../../api/constApi";
import { honoredListApi, honoredChangeStatusApi, AddEditHonoredApi, honoredDeleteApi } from "../Services/honoredService";

export const honoredList = createAsyncThunk(HONORED_LIST, async (payload) => {
    const response = await honoredListApi(payload);
    return response.data;
});

export const honoredChangeStatus = createAsyncThunk(HONORED_CHANGE_STATUS, async (payload) => {
    const response = await honoredChangeStatusApi(payload);
    return response.data;
});

export const addEditHonored = createAsyncThunk(HONORED_ADDEDIT, async (payload) => {
    const response = await AddEditHonoredApi(payload);
    return response.data;
});

// export const fundsWopList = createAsyncThunk(FUND_WOP_LIST, async (payload) => {
//     const response = await fundWopListApi(payload);
//     return response.data;
// });

export const honoredDelete = createAsyncThunk(HONORED_DELETE, async (payload) => {
    const response = await honoredDeleteApi(payload);
    return response.data;
});

export const honoredSlice = createSlice({
    name: "honored",
    initialState: {
        honored: null,
        // districtWop: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(honoredList.fulfilled, (state, action) => {
            state.honored = action?.payload;
        });
        builder.addCase(addEditHonored.fulfilled, (state, action) => {
            state.honored = action?.payload?.Data;
        });
    }
});

export default honoredSlice.reducer;